import React, { Component } from 'react'
import styled from 'styled-components'
import ProductDetail from './ProductDetail'

import SelectBox from './SelectBox'
import { colors, rhythm, fonts, media } from '../utils/style-utils'

import bg from '../img/stained-background.jpg'
import radioChecked from '../img/radio-checked.svg'
import radioUnchecked from '../img/radio-unchecked.svg'

const ProductFilterWrapper = styled.section`
  background: url(${bg});
  background-position: center;
  background-size: cover;
  color: ${colors.white};
  padding: ${rhythm(5)} 0;
  margin-top: ${rhythm(5)};
`

const Title = styled.h2`
  font-weight: normal;
  line-height: 1.2;
  font-family: ${fonts.special};
  text-align: center;

  font-size: 1.5rem;

  ${media.tablet`
    font-size: 2rem;
  `};

  ${media.desktop`
    font-size: 3.66rem;
  `};
`

const ProductFilterGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: ${rhythm(3)} 0;
  justify-content: center;
  ${media.tablet`
    margin-right: -2em;
  `};
`

const ProductFilterGridItem = styled.div`
  width: 100%;
  margin-bottom: 2em;
  ${media.tablet`
    margin-bottom: 0;
    width: 33.33%;
    padding-right: 2em;
  `};
`

const NoResults = styled.div`
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
`

const Radio = styled.label`
  & + & {
    margin-left: 2em;
  }
  input {
    opacity: 0;
    position: absolute;
  }

  input:checked ~ span::before {
    background-image: url(${radioChecked});
  }

  span {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    letter-spacing: 0.21em;
    text-align: center;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      display: block;
      background-image: url(${radioUnchecked});
      background-repeat: no-repeat;
      width: 25px;
      height: 25px;
      background-position: center;
      margin-right: 1em;
    }
  }
`

const RadioGroup = styled.div`
  margin-top: ${rhythm(2)};
  display: flex;
  justify-content: center;
  align-items: center;
`

class ProductFilter extends Component {
  constructor(props) {
    super(props)

    this.handleCategoryUpdate = this.handleCategoryUpdate.bind(this)
    this.handleSubCategoryUpdate = this.handleSubCategoryUpdate.bind(this)
    this.handleStainTypeChange = this.handleStainTypeChange.bind(this)
  }
  state = {
    mainCategory: null,
    subCategoryList: null,
    subCategory: null,
    matchingProducts: null,
    stainType: 'persistent',
    water: false,
  }

  componentWillMount() {
    this.getMatchingProducts()
  }

  getSKUs() {
    if (!this.state.mainCategory || !this.state.subCategory) return null

    let SKUs = this.state.subCategoryList.filter(
      subCategory => subCategory.name === this.state.subCategory
    )[0]

    if (this.state.stainType === 'fresh') {
      SKUs = SKUs.fresh_stains
    } else {
      SKUs = SKUs.persistent_stains
    }

    SKUs = SKUs.map(product => product.product_name)
    return SKUs
  }

  getMatchingProducts() {
    let products = null
    const SKUs = this.getSKUs()
    console.log('skus', SKUs)
    if (SKUs == null) return false

    try {
      products = this.props.data.edges.filter(
        edge => SKUs.indexOf(edge.node.frontmatter.sku) > -1
      )
    } catch (error) {
      products = null
    }
    return this.setState({
      matchingProducts: products,
      water: SKUs.indexOf('water') > -1,
    })
  }

  handleCategoryUpdate(selectedOption) {
    if (!selectedOption) return false
    const subCategories = this.props.product_categories.filter(
      item => item.name === selectedOption
    )[0].subCategories
    return this.setState({
      mainCategory: selectedOption,
      subCategoryList: subCategories,
      subCategory: null,
    })
  }

  handleSubCategoryUpdate(selectedOption) {
    console.log('update sub')
    if (!selectedOption) return false
    return this.setState(
      {
        subCategory: selectedOption,
      },
      this.getMatchingProducts
    )
  }

  handleStainTypeChange(e) {
    this.setState({ stainType: e.target.value }, this.getMatchingProducts)
  }

  render() {
    const {
      id,
      title,
      fresh_label,
      persistent_label,
      sub_placeholder_label,
      main_placeholder_label,
      water_disclaimer,
      dynamic_product_title,
      product_categories,
      order_label,
    } = this.props
    let NoResultsLabel = ''

    console.log(product_categories)

    this.state.subCategory && this.state.subCategory.value === 'water'
      ? water_disclaimer
      : 'No matching products found'
    return (
      <ProductFilterWrapper id={id}>
        <div className="l-constrained">
          <Title>{title}</Title>
          <RadioGroup>
            <Radio htmlFor="type-persistent">
              <input
                type="radio"
                id="type-persistent"
                name="stain-type"
                value="persistent"
                onChange={this.handleStainTypeChange}
                checked={this.state.stainType === 'persistent'}
              />
              <span>{persistent_label}</span>
            </Radio>
            <Radio htmlFor="type-fresh">
              <input
                type="radio"
                id="type-fresh"
                name="stain-type"
                value="fresh"
                onChange={this.handleStainTypeChange}
                checked={this.state.stainType === 'fresh'}
              />
              <span>{fresh_label}</span>
            </Radio>
          </RadioGroup>
          <ProductFilterGrid>
            <ProductFilterGridItem>
              <SelectBox
                options={product_categories}
                value={this.state.mainCategory}
                onChange={this.handleCategoryUpdate}
                placeholder={main_placeholder_label}
              />
            </ProductFilterGridItem>
            {this.state.mainCategory && (
              <ProductFilterGridItem>
                <SelectBox
                  options={this.state.subCategoryList}
                  value={this.state.subCategory}
                  onChange={this.handleSubCategoryUpdate}
                  placeholder={sub_placeholder_label}
                />
              </ProductFilterGridItem>
            )}
          </ProductFilterGrid>
          {this.state.mainCategory &&
            this.state.subCategory && (
              <div>
                {this.state.matchingProducts ? (
                  this.state.matchingProducts.map(product => (
                    <ProductDetail
                      dynamic_title={dynamic_product_title}
                      key={product.node.frontmatter.sku}
                      category={this.state.subCategory}
                      data={product.node}
                      order_label={order_label}
                    />
                  ))
                ) : (
                  <NoResults>{NoResultsLabel}</NoResults>
                )}
                {this.state.water && <NoResults>{water_disclaimer}</NoResults>}
              </div>
            )}
        </div>
      </ProductFilterWrapper>
    )
  }
}

export default ProductFilter



// WEBPACK FOOTER //
// ./src/components/ProductFilter.js